export default __webpack_public_path__ + "static/media/edison2021-dsci-framework-web-v11.e16b2bff.png";